/* Hollywood Skincare Listicle — section JS
   - Sticky CTA scroll trigger with dismiss (sessionStorage)
   - Show-more comments toggle
*/
(function () {
  'use strict';

  // ===== Sticky CTA =====
  function initStickyCta() {
    var bar = document.querySelector('[data-hsl-sticky-cta]');
    if (!bar) return;

    var closeBtn = bar.querySelector('[data-hsl-sticky-cta-close]');
    var triggerPercent = parseInt(bar.getAttribute('data-trigger-percent'), 10) || 50;
    var dismissKey = 'hsl_sticky_cta_dismissed';
    var dismissed = false;

    try {
      if (sessionStorage.getItem(dismissKey) === '1') dismissed = true;
    } catch (e) { /* sessionStorage unavailable */ }

    bar.removeAttribute('hidden');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        try { sessionStorage.setItem(dismissKey, '1'); } catch (e) {}
        bar.classList.remove('hsl__sticky-cta--visible');
      });
    }

    function update() {
      if (dismissed) {
        bar.classList.remove('hsl__sticky-cta--visible');
        return;
      }
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var scrollHeight = doc.scrollHeight - window.innerHeight;
      var percent = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      if (percent >= triggerPercent) {
        bar.classList.add('hsl__sticky-cta--visible');
      } else {
        bar.classList.remove('hsl__sticky-cta--visible');
      }
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // ===== Show more comments =====
  function initShowMore() {
    var btns = document.querySelectorAll('[data-hsl-show-more]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        var container = btn.closest('.hsl__comments');
        if (!container) return;
        container.setAttribute('data-expanded', 'true');
        btn.setAttribute('aria-expanded', 'true');
        btn.style.display = 'none';
      });
    });
  }

  // ===== Hide theme header fallback =====
  // Modern browsers handle this via CSS :has(). Older browsers get the class.
  function initHideThemeChrome() {
    if (document.querySelector('.shopify-section--hsl')) {
      document.body.classList.add('hsl-hide-theme-chrome');
    }
  }

  function init() {
    initHideThemeChrome();
    initStickyCta();
    initShowMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
